import React, { memo } from 'react';

type Props = {
  className?: string;
};

export const NBCFLabel: React.FC<Props> = ({ className }) => (
  <div
    className={`tw:inline-block tw:w-fit tw:rounded-full tw:bg-pink-400 tw:px-3 tw:py-1 tw:text-xs tw:font-semibold tw:text-white ${
      className || ''
    }`}>
    Support the Cause
  </div>
);

export default memo(NBCFLabel);
